<!-- 优惠券改版，目前暂时仅在电影业务使用 -->
<template>
    <div
        @click="emitItemClick"
        class="coupon-item"
        :class="{
            [type]: true,
            [couponStatusClass]: !!couponStatusClass,
            received: isReceivedByClick,
            expand: isExpand,
            usecheck: isUseCheck,
            'has-not-received-badge': hasNotReceivedBadge,
            'not-amount-received': isEmpty,
        }"
    >
        <div class="main">
            <div class="denomination">
                <div class="amount double" v-if="isDoubleCard">
                    <span class="symbol">X</span>
                    <span class="num">{{ coupon.amount }}</span>
                    <span class="suffix">倍</span>
                </div>
                <div class="amount cashback" v-else-if="isCashBackCard">
                    <span class="num">{{ cashBackInfo.amount }}</span>
                    <span class="suffix">{{ cashBackInfo.suffix }}</span>
                </div>
                <div v-else-if="coupon.amount" class="amount">
                    <span class="symbol">¥</span>
                    <span class="num">{{ coupon.amount }}</span>
                </div>
                <div class="amount" v-else>
                    <span class="num">{{ coupon.discount }}</span>
                    <span class="suffix">折</span>
                </div>
                <div
                    v-if="!(isDoubleCard || isCashBackCard) && coupon.couponInfo"
                    class="rule"
                    v-html="coupon.couponInfo"
                ></div>
            </div>
            <div class="info">
                <div class="name-wrap">
                    <img v-if="coupon.isGoldCard" class="gold-ico" src="./images/gold-card.png" alt="" />
                    <div v-else-if="type !== 'kfc'" class="tag">{{ couponType }}</div>
                    <div class="name">{{ coupon.couponName }}</div>
                </div>
                <div class="expires-wrap" @click.stop="onExpand">
                    <p class="expires">{{ date }}</p>
                    <i class="more"></i>
                </div>
            </div>
            <div class="operation">
                <template v-if="showCheckBtn">
                    <div class="checkbox">
                        <i class="icon" :class="checked === true ? 'icon-checked' : 'icon-unchecked'"></i>
                    </div>
                </template>
                <template v-else>
                    <div v-if="showToUseBtn" class="btn">
                        去使用
                    </div>
                    <div v-if="showReceiveBtn" class="btn">立即领取</div>
                </template>
            </div>
        </div>
        <div class="desc-wrap" v-if="coupon.description">
            <div ref="desc" class="desc" v-html="coupon.description"></div>
        </div>
    </div>
</template>

<script>
// todo: 根据userId和couponId缓存已领取状态(只在领取页面)
import { receiceCoupon } from 'root/coupon/api/receiveCoupon.js';
import { isValidDate, setReceiveCouponCache, receiveEmptyResult, receiveExpirationTimeRange } from './utils/index';
import loginState from 'root/common/util/getLoginState.js';
import { seckiller as countdown } from 'root/blackcard/components/mixin/seckiller';
import {
    emptyStatus,
    timeoutStatus,
    usedStatus,
    receiveStatus,
    canReceiveStatus,
    continueReceiveStatus,
    activeStatus,
    urlObjs,
    coundownMaxDay,
} from './mock/index';
import env from '@/common/util/env';

const couponTarget = {
    QSSC_GOODS: '商城券',
    QSC_TICKET: '美食购物券',
    QSC_RECHARGE: '充值券',
    CPS_TBK_GOODS: '翻倍卡',
    QSC_MOVIE: '电影票',
    QSC_FRIED_CHICKEN: '肯德基',
};

export default {
    mixins: [countdown('countdownData', true)],
    props: {
        coupon: {
            require: true,
            type: Object,
        },
        useMethod: {
            default: 'check', // 可选值 1.click: 点击事件  2.check: 选择    ...
            type: String,
        },
        checked: {
            default: false,
            type: Boolean,
        },
        disable: {
            default: false,
            type: Boolean,
        },
        // 是否隐藏去使用按钮
        showGotoUseBtn: {
            default: true,
            type: Boolean,
        },
        showReceiveIcon: {
            default: true,
            type: Boolean,
        },
        // 是否默认展开
        expandDefault: {
            default: false,
            type: Boolean,
        },
        // 自定义去使用按钮 会抛出事件
        customGotoUse: {
            default: false,
            type: Boolean,
        },
        showExpiresSoon: {
            default: false,
            type: Boolean,
        },
        receiveCacheTime: {
            type: Number,
            default: receiveExpirationTimeRange,
        },

        isShowCheck: {
            type: Boolean,
            default: true,
        },
        tabLabel: {
            type: String,
            default: '',
        },
        business: {
            type: String,
            default: '',
        },
    },
    filters: {
        formatCouponPrice(num) {
            if (typeof num !== 'number') num = parseFloat(num);
            if (Number.isNaN(num)) return '';
            return num.toFixed(2);
        },
    },
    watch: {
        'coupon.couponEndTime': function() {
            this.resetTimeDown();
        },
    },
    inject: ['handleGoldSigning'],
    created() {
        this.resetTimeDown();
    },
    mounted() {
        this.$nextTick(() => {
            if (this.expandDefault) {
                this.isExpand = true;
            }
        });
    },
    data() {
        return {
            isExpand: false,
            continueReceiveStatus,
            coundownMaxDay,
            countdownData: {
                liveEndTime: 0,
                serverTime: 0,
            },
        };
    },
    computed: {
        // 是否可用
        active() {
            // const start = new Date(this.coupon.couponStartTime);
            // const end = new Date(this.coupon.couponEndTime);
            // if (!isValidDate(start) || !isValidDate(end)) {
            //     console.log('invalid Date');
            //     return false;
            // }
            // const now = new Date().getTime();
            // if (now < end.getTime() && now > start.getTime()) {
            //     return true;
            // }
            // return false;
            if (this.disable) {
                return false;
            }
            // 倒计时结束 变成过期样式
            if (this.isSellout) {
                return false;
            }
            return activeStatus.includes(this.coupon.status);
        },
        cashBackInfo({ coupon }) {
            const REG = /^(100|[1-9]?\d(\.\d\d?\d?)?)%$|0$/;
            const isPercent = REG.test(coupon.couponInfo);
            return {
                amount: isPercent ? coupon.amount : coupon.couponInfo,
                suffix: isPercent ? '%' : '',
            };
        },
        dayLeft() {
            if (this.countDownObj && this.countDownObj.days) {
                return this.countDownObj.days;
            }
            return 0;
        },
        timeRange() {
            let start, end;
            if (this.coupon.couponStartTime) start = new Date(this.coupon.couponStartTime.replace(/-/g, '/'));
            if (this.coupon.couponEndTime) end = new Date(this.coupon.couponEndTime.replace(/-/g, '/'));
            if (!isValidDate(start) || !isValidDate(end)) {
                return '-';
            }
            return (
                `${start.getFullYear()}.${start.getMonth() + 1}.${start.getDate()}` +
                '-' +
                `${end.getFullYear()}.${end.getMonth() + 1}.${end.getDate()}`
            );
        },
        dateRange({ coupon }) {
            const { couponStartTime, couponEndTime } = coupon;
            let start, end;
            if (couponStartTime) start = new Date(couponStartTime.replace(/-/g, '/'));
            if (couponEndTime) end = new Date(couponEndTime.replace(/-/g, '/'));
            if (!isValidDate(start) || !isValidDate(end)) {
                return '-';
            }
            return `${start.getFullYear()}.${start.getMonth() +
                1}.${start.getDate()}-${end.getFullYear()}.${end.getMonth() + 1}.${end.getDate()}`;
        },
        expiresSoon() {
            const { couponEndTime, status } = this.coupon;
            if (!couponEndTime || status !== 2 || !this.showExpiresSoon) return false; // 未使用状态，才会即将过期
            const endDate = new Date(couponEndTime.replace(/-/g, '/'));
            const now = new Date();
            return endDate.getTime() - now.getTime() < 12 * 60 * 60 * 1000; // 距离结束时间12小时标记为即将过期
        },
        statusIconClass() {
            const prefix = 'status-';
            if (this.coupon.status == usedStatus) {
                return `${prefix}used`;
            }
            // 倒计时结束或后台返回已结束 变成过期样式
            if (this.coupon.status == timeoutStatus || this.isSellout) {
                return `${prefix}timeout`;
            }
            if (this.coupon.status == 2) {
                return this.showReceiveIcon ? `${prefix}receive` : '';
            }
            if (this.coupon.status == emptyStatus) {
                return `${prefix}empty`;
            }
            return '';
        },
        showToUseBtn() {
            return (
                this.active === true &&
                this.useMethod === 'click' &&
                this.showGotoUseBtn &&
                this.coupon.status == receiveStatus
            );
        },
        showContinueBtn() {
            return this.active === true && this.useMethod === 'click' && this.coupon.status == continueReceiveStatus;
        },
        showReceiveBtn() {
            return this.active === true && this.useMethod === 'click' && this.coupon.status == canReceiveStatus;
        },
        showCheckBtn() {
            return this.active === true && this.useMethod === 'check' && this.isShowCheck;
        },
        receiveBtnText() {
            return this.coupon.status == continueReceiveStatus ? '继续领取' : '立即领取';
        },
        couponType() {
            const couponType = this.coupon.couponType;
            if (couponType === 'DOUBLE_CARD') {
                return '翻倍卡';
            }
            if (couponType === 'RE_CASH_CARD') {
                return '返现卡';
            }
            return couponTarget[this.coupon.couponTarget];
        },
        isDoubleCard() {
            return this.coupon.couponType === 'DOUBLE_CARD';
        },
        isCashBackCard() {
            return this.coupon.couponType == 'RE_CASH_CARD';
        },
        type({ coupon }) {
            const couponTargetMap = {
                QSSC_GOODS: 'food',
                QSC_TICKET: 'ticket',
                QSC_RECHARGE: 'recharge',
                QSC_MOVIE: 'movie',
                QSC_FRIED_CHICKEN: 'kfc',
            };
            return couponTargetMap[coupon.couponTarget];
        },
        // 已过期
        isExpired({ coupon, isSellout }) {
            return coupon.status == timeoutStatus || isSellout;
        },
        // 已领取状态
        isReceived({ coupon }) {
            return coupon.status === receiveStatus;
        },
        isUsed({ coupon }) {
            return coupon.status == usedStatus;
        },
        // 已领完
        isEmpty({ coupon }) {
            return coupon.status === emptyStatus;
        },
        isReceivedByClick({ isReceived, useMethod }) {
            return isReceived && useMethod === 'click';
        },
        descHeight({ isExpand }) {
            const height = `${this.$refs.desc?.offsetHeight || 0}px`;
            return isExpand ? height : '0.2rem';
        },
        // 新到/快过期
        couponStatusClass({ coupon, isUsed, isExpired, disable }) {
            let cls = '';
            const THREE_DAYS = 3 * 24 * 60 * 60 * 1000;
            const { couponEndTime, receiveTime, status } = coupon;
            const endDate = couponEndTime && new Date(couponEndTime.replace(/-/g, '/'));
            const receiveDate = receiveTime && new Date(receiveTime.replace(/-/g, '/'));
            const now = new Date();
            // 距离结束时间3天标记为即将过期 (未使用状态，才会即将过期)
            if (status === receiveStatus && endDate && endDate.getTime() - now.getTime() < THREE_DAYS)
                cls = 'expires-soon';
            // 当天领取标记为新到
            if (
                status === receiveStatus &&
                receiveDate &&
                receiveDate.setHours(0, 0, 0, 0) === now.setHours(0, 0, 0, 0)
            )
                cls = 'new';
            if (disable) cls = 'disabled';
            if (isExpired) cls = 'expired';
            if (isUsed) cls = 'used';
            return cls;
        },
        showCountDown({ isReceived, isSellout, countDownTime, countDownObj, dayLeft, coundownMaxDay }) {
            return isReceived && !isSellout && countDownTime && countDownObj && dayLeft < coundownMaxDay;
        },
        date({ coupon, showCountDown, dateRange, dayLeft, countDownObj }) {
            const countDownText = showCountDown
                ? `仅剩${
                      dayLeft <= 0
                          ? `${countDownObj.hours}:${countDownObj.minutes}:${countDownObj.seconds}`
                          : `${dayLeft}天`
                  }`
                : '';
            const dateText = coupon.couponTimeStr ? coupon.couponTimeStr : dateRange;
            return countDownText ? `${countDownText}到期` : dateText;
        },
        isUseCheck({ useMethod }) {
            return useMethod === 'check';
        },
    },
    methods: {
        resetTimeDown() {
            // 倒计时数据
            this.countdownData.liveEndTime = this.coupon.couponEndTime
                ? new Date(this.coupon.couponEndTime.replace(/-/g, '/')).getTime()
                : 0;
            this.countdownData.serverTime = new Date().getTime();
            this.initTimeDown();
        },
        clickHandle() {
            this.$emit('click');
        },
        clickCouponPoint(obj_id) {
            const coupon = this.coupon;
            window.bigTj?.track('click', {
                obj_id,
                obj_type: 'my_couponlist',
                coupon_name: coupon.couponName,
                coupon_id: coupon.couponId,
                item_type: this.tabLabel,
            });
        },
        // 新增点击“去使用”埋点
        clickUseBtn() {
            this.emitItemClick('use_coupon');
        },
        // 分发点击事件
        emitItemClick(obj_id) {
            this.$emit('beforeClick', this.coupon);
            this.clickCouponPoint(obj_id);
            const coupon = this.coupon;
            if (this.business === 'recharge') {
                if (coupon && coupon.isFake == true) {
                    //假券不可点击
                    this.handleGoldSigning('coupon');
                    this.clickHandle();
                }
            }
            const def1 =
                coupon.couponType == 'RE_CASH_CARD' &&
                (coupon.couponTarget == 'QSC_PERIPHERY' || coupon.couponTarget == 'QSC_MOVIE');
            const def2 = env.isIos && coupon.couponType == 'REDUCTION_COUPON' && coupon.couponTarget == 'QSC_RECHARGE';
            if (env.isMainMiniProgram && (def1 || def2)) {
                this.$toast('请到APP去使用');
                return;
            }
            if (this.showToUseBtn) {
                this.gotoUse();
            } else if (this.showReceiveBtn || this.showContinueBtn) {
                this.receive();
            } else if (this.showCheckBtn) {
                this.clickHandle();
            } else {
                console.log('do nothing');
            }
        },

        receive() {
            // 判断是否登录
            if (!loginState()) {
                this.$emit('showloginwall');
                return;
            }
            const coupon = this.coupon;
            if (coupon.status != receiveStatus) {
                if (coupon.receiveStatus === false) {
                    this._toast(coupon.receiveMsg || '领取已达到上限');
                    return;
                }
                const couponType = {
                    QSSC_GOODS: undefined, //默认情况
                    QSC_TICKET: 'ticket',
                    QSC_RECHARGE: 'recharge',
                    QSC_MOVIE: 'movie',
                    QSC_FRIED_CHICKEN: 'kfc',
                };

                receiceCoupon({
                    couponId: coupon.couponId,
                    type: couponType[coupon.couponTarget],
                })
                    .then(res => {
                        if (res.code == 200) {
                            if (res.data) {
                                if (res.data.flag == true) {
                                    this.$toast({
                                        message: `已为你成功领取${coupon.couponInfo || ''}优惠券`,
                                        iconClass: 'icon icon-success',
                                    });
                                    setReceiveCouponCache(coupon.couponId, this.receiveCacheTime);
                                } else {
                                    if (res.data.used) {
                                        // 改变为立即使用状态 status = 2 (已经领取过但是没有对应的缓存，所以要加入缓存并且修改按钮样式)
                                        setReceiveCouponCache(coupon.couponId, this.receiveCacheTime);
                                    }
                                    // 被领取完
                                    // status表示领取领取优惠券状态 而不是优惠券状态 注意和coupon.status不是同一个status
                                    // 记录缓存5分钟
                                    if (res.data.status != null && res.data.status == 2) {
                                        receiveEmptyResult(coupon.couponId);
                                    }
                                    // 每人最多领取n张 当做已领取处理
                                    // if (res.data.status != null && res.data.status == 4) {
                                    //     setReceiveCouponCache(this.coupon.couponId);
                                    // }
                                    this._toast(res.data.msg);
                                }
                                this.$emit('onReceive', res.data);
                            } else {
                                this._toast(res.msg);
                            }
                            this.$emit('on-receive', res.data);
                        } else {
                            this.$emit('onReceive', res.msg);
                            this._toast(res.msg);
                        }
                    })
                    .catch(e => {
                        console.log('e:', e);
                        this.$emit('onReceive', e);
                        this._toast('网络错误，请刷新重试');
                    });
            }
            this.clickHandle();
        },

        gotoUse() {
            if (this.customGotoUse) {
                this.$emit('gotoUse');
                return;
            }
            if (this.coupon.linkUrl) {
                // 跳接口返回的地址
                this.jumpUrl(this.coupon.linkUrl);
            } else if (this.isDoubleCard) {
                // 翻倍卡跳首页
                this.jumpUrl('home');
            } else if (this.isCashBackCard) {
                this.jumpUrl('privilege');
            } else {
                // 无配置地址则跳凑单页面
                window.location.href =
                    '/new/coupon/getGoods/getGoods.html?ZZCAppArg=topbar_remove&id=' +
                    this.coupon.couponId +
                    '&couponName=' +
                    encodeURIComponent(this.coupon.couponInfo);
            }
        },
        jumpUrl(link) {
            const urlObj = urlObjs.find(e => e.route == link);
            if (urlObj) {
                if (env.isApp) {
                    // app 提审处理
                    if (window.appIsTiShen == 1) {
                        window.ZZCFL.Utils.nativeTabSwitch('shop');
                        return;
                    }
                    window.ZZCFL.Utils.nativeTabSwitch(urlObj.nativeTab);
                } else if (env.isMainMiniProgram) {
                    // 骑士卡小程序
                    window.wx.miniProgram.reLaunch({
                        url: urlObj.miniPath,
                    });
                } else {
                    window.location.href = urlObj.link;
                }
            } else {
                window.location.href = link;
            }
        },
        onExpand() {
            this.clickCouponPoint('coupon_detail');
            this.isExpand = !this.isExpand;
        },
        _toast(options) {
            if (!options) return;
            const defaultConfig = {
                className: 'coupon-item-toast',
            };
            let config = {};
            let formatConfig = {};
            if (typeof options == 'string') {
                formatConfig.message = options;
            } else if (typeof options == 'object') {
                formatConfig = options;
            }
            config = {
                ...defaultConfig,
                ...formatConfig,
            };

            if (this.$toast) {
                this.$toast(config);
            } else {
                window.ZZCFL.Toast(config);
            }
        },
    },
};
</script>

<style scoped lang="scss">
// @import '~root/common/fonts/fonts.scss';
@import './style/coupon.scss';
// @import './style/food.scss';
// @import './style/recharge.scss';
// @import './style/oil.scss';
@import './style/movie.scss';
@import './style/kfc.scss';
@import './style/received.scss';
@import './style/expand.scss';
@import './style/disabled.scss';
@import './style/checked.scss';
</style>

<style lang="scss">
.mint-toast {
    &.coupon-item-toast {
        background: rgba(51, 51, 51, 0.8);
        padding: 0.3rem !important;
        border-radius: 0.16rem;
        .mint-toast-text {
            line-height: normal;
            font-size: 0.28rem;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #ffffff;
            white-space: nowrap;
        }
    }
}
</style>
